// Ensures a meta description tag is present in the document head
const ensureMetaDescription = () => {
    let metaDescription = document.querySelector('meta[name="description"]')

    if (!metaDescription) {
        metaDescription = document.createElement('meta')
        metaDescription.setAttribute('name', 'description')
        document.head.append(metaDescription)
    }

    return metaDescription
}

const ensureRobotsMeta = () => {
    let robotsMeta = document.querySelector('meta[name="robots"]')

    if (!robotsMeta) {
        robotsMeta = document.createElement('meta')
        robotsMeta.setAttribute('name', 'robots')
        document.head.append(robotsMeta)
    }

    return robotsMeta
}

// Sets the page metadata
export const setPageMetadata = ({
    description,
    noIndex = false,
    title,
}) => {
    if (title) {
        document.title = title
    }

    if (description) {
        const metaDescription = ensureMetaDescription()
        metaDescription.setAttribute('content', description)
    }

    const existingRobotsMeta = document.querySelector('meta[name="robots"]')
    if (noIndex) {
        const robotsMeta = ensureRobotsMeta()
        robotsMeta.setAttribute('content', 'noindex,follow')
    } else if (existingRobotsMeta) {
        existingRobotsMeta.remove()
    }
}
